import { render, staticRenderFns } from "./mission-vision.vue?vue&type=template&id=531f938c&"
import script from "./mission-vision.vue?vue&type=script&lang=js&"
export * from "./mission-vision.vue?vue&type=script&lang=js&"
import style0 from "./mission-vision.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports